import React, { useEffect, useState } from 'react';

export const TabsReportes = ({ listaMenus = [] }) => {

    const [reporteAbierto,setReporteAbierto] = useState('Home')
    const [reportesActivos, setReportesActivos] = useState(['Home']);
    const [componentes,setComponentes] = useState([])

    useEffect(() => {
        const cargarComponentes =  async () => {
            const nuevosComponentes = await Promise.all(
                listaMenus.map(async (data) => {
                    const modulo = await import(`../../pages/Reportes/vistasReportes/${data.codigoReporte}`)
                    return {
                        nombre: data.codigoReporte,
                        componente: modulo.default
                    }
                })
            )
            setComponentes([{nombre: 'Home',componente: MenuPrincipal},...nuevosComponentes])
        }

        cargarComponentes()
    },[listaMenus])     // RECARGA LAS VECES QUE LISTAMENUS SE ACTUALIZA

    const MenuPrincipal = () => {
        return (
            <div className={`containerScroll w-full h-full overflow-auto`}>
                <table className='table'>
                    <thead>
                        <tr>
                            <th className='text-left'>Nº</th>
                            <th className='text-left'>CÓDIGO</th>
                            <th className='text-left'>TÍTULO</th>
                            <th className='text-left'>NOMBRE</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            listaMenus.map((data,i) => {
                                return(
                                    <tr 
                                        key={i+1} 
                                        onClick={() => {
                                            abrirReporte(data.codigoReporte)
                                        }}
                                    >
                                        <td className=''>{i+1}</td>
                                        <td className=''>{data.codigoReporte}</td>
                                        <td className=''>{data.nomReporte}</td>
                                        <td className=''>{data.tituloReporte}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    };

    const ContenidoVariable = () => {
        return(
            <>
                {
                    componentes.map(({nombre:nombreComponente,componente:ComponenteDinamico},i) => (
                        <div key={i+1} className={`${reporteAbierto == nombreComponente ? '' : 'hidden'} w-full h-full`}>
                            <ComponenteDinamico/>
                        </div>
                    ))
                }
            </>
        )

    }

    const abrirReporte = (nombreReporte) => {
        console.log("reportesActivos -> ",reportesActivos)
        if(!reportesActivos.some(e => e == nombreReporte)){
            setReporteAbierto(nombreReporte)
            setReportesActivos((valorAnterior) => {
                return [...valorAnterior,nombreReporte]
            })
        }
    }

    const eliminarReporte = (nombreReporte) => {
        setReporteAbierto('Home')
        setReportesActivos((valorAnterior) => {
            return valorAnterior.filter(e => e != nombreReporte)
        })
    }
    
    return (
        <div className='w-full h-full flex flex-col'>
            <div className='flex pt-[7px]'>
                <div onClick={() => setReporteAbierto('Home')} className={`${reporteAbierto == 'Home' ? 'bg-blue-900' : ''} py-2 px-3 border flex items-center rounded-t-lg cursor-pointer`}>Home</div>
                {listaMenus.map((data, i) => {
                    return (
                        <div key={i + 1} onClick={() => setReporteAbierto(data.codigoReporte)} className={`${reportesActivos.some(e => e == data.codigoReporte) ? '' : 'hidden'} ${reporteAbierto == data.codigoReporte ? 'bg-blue-900' : ''} py-1 px-3 border flex items-center rounded-t-lg relative cursor-pointer`}>
                            {data.codigoReporte}
                            <div onClick={(e) => {e.stopPropagation();eliminarReporte(data.codigoReporte)}} className='hover:scale-110 rounded-full border absolute top-0 -translate-y-1/2 translate-x-1/2 right-0 w-4 h-4 flex items-center justify-center bg-red-600 cursor-pointer'><i className="fa fa-times text-xs" aria-hidden="true"></i></div>
                        </div>
                    );
                })}
            </div>
            <div className='flex-1 border-t w-full overflow-auto p-4 flex'>
                {/* PARA QUE CONTENIDO VARIABLE NO ACTUE COMO UN COMPONENTE Y NO SE RECARGUE CADA VEZ QUE SE ABRE EL MENU */}
                {/* <ContenidoVariable></ContenidoVariable> */}
                {ContenidoVariable()}
            </div>
        </div>
    );
};
